import script from "./QuickReply.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickReply.vue?vue&type=script&setup=true&lang=js"

import "./QuickReply.vue?vue&type=style&index=0&id=43bbfd94&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43bbfd94"]])

export default __exports__